import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  labelMobile: {
    '&&': {
      width: 180,
      height: 60,
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(7),

      [theme.breakpoints.up('laptop')]: {
        display: 'none',
      },
    },
  },
  contentWrapper: {
    '&&': {
      position: 'relative',

      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
    },
  },
  containerField: {
    '&&': {
      [theme.breakpoints.down('tablet')]: {
        width: 334,

        marginTop: theme.spacing(1),
      },

      [theme.breakpoints.up('tablet')]: {
        width: 380,

        marginTop: theme.spacing(3),
      },
    },
  },
  containerTitle: {
    '&&': {
      marginBottom: SPACES.xxxxxxl,
    },
  },
  button: {
    '&&': {
      // borderRadius: 40,
      fontWeight: 700,
      textTransform: 'capitalize',
      color: theme.palette.custom.white,

      [theme.breakpoints.down('tablet')]: {
        marginTop: theme.spacing(4),

        fontSize: FONTS.SIZES.s,
      },
      [theme.breakpoints.up('tablet')]: {
        marginTop: theme.spacing(5),

        fontSize: FONTS.SIZES.xl,
      },

      [theme.breakpoints.down('tablet')]: {
        width: 334,
        height: 45,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 380,
        height: 65,
      },
    },
  },
  InputProps: {
    '&&': {
      fontWeight: '700',
      color: theme.palette.custom.darkBlue2,
      zIndex: 1,
      '&:-webkit-autofill': {
        transition: 'background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s',
        transitionDelay: 'background-color 5000s, color 5000s',
      },
      '&:-webkit-autofill:hover': {
        transition: 'background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s',
        transitionDelay: 'background-color 5000s, color 5000s',
      },
      '&:-webkit-autofill:focus': {
        transition: 'background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s',
        transitionDelay: 'background-color 5000s, color 5000s',
      },
      '&:-webkit-autofill:active': {
        transition: 'background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s',
        transitionDelay: 'background-color 5000s, color 5000s',
      },

      [theme.breakpoints.down('tablet')]: {
        // height: 23,

        fontSize: FONTS.SIZES.s,
      },
      [theme.breakpoints.up('tablet')]: {
        // height: 35,

        fontSize: FONTS.SIZES.m,
      },
    },
  },
  TextInput: {
    '&&': {
      [`& fieldset`]: {
        // [theme.breakpoints.down('tablet')]: {
        //   background: theme.palette.custom.grey,
        // },
        // [theme.breakpoints.up('tablet')]: {
        //   background: theme.palette.custom.secondary,
        // },
      },
      '& label.Mui-focused': {
        color: theme.palette.custom.white,
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: theme.palette.custom.primary,
      },
      '& .MuiOutlinedInput-root': {
        // '& fieldset': {
        //   borderColor: theme.palette.custom.primary,
        // },
        '&:hover fieldset': {
          borderColor: theme.palette.custom.primary,
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.custom.primary,
        },
        '&.Mui-disabled fieldset': {
          borderColor: theme.palette.grey[400],
        },
      },
      '& .MuiFormHelperText-root': {
        color: 'red',
      },

      [theme.breakpoints.down('tablet')]: {
        width: 334,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 380,
      },
    },
  },
  TextInputLabel: {
    '&&': {
      [theme.breakpoints.up('tablet')]: {
        display: 'none',
      },

      color: theme.palette.custom.darkBlue2,
      fontFamily: FONTS.FAMILIES.notoSans,
      fontWeight: 700,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.25,

      marginBottom: theme.spacing(1),
    },
  },
  formControlLabel: {
    '&&': {
      fontSize: FONTS.SIZES.s,
      fontWeight: '700',

      [theme.breakpoints.down('tablet')]: {
        color: theme.palette.custom.primary,
      },
      [theme.breakpoints.up('tablet')]: {
        color: theme.palette.custom.grey2,
      },
    },
  },
  signUpContainer: {
    '&&': {
      [theme.breakpoints.up('laptop')]: {
        marginTop: theme.spacing(5),
        marginRight: theme.spacing(6),
        marginBottom: theme.spacing(10),
      },
    },
  },
  textSignUp: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1.35,

      [theme.breakpoints.down('laptop')]: {
        fontSize: FONTS.SIZES.s,
        fontWeight: '500',
        color: theme.palette.custom.darkBlue2,
      },
      [theme.breakpoints.up('laptop')]: {
        fontWeight: '500',
        fontSize: FONTS.SIZES.m,
        color: theme.palette.custom.grey2,
      },
    },
  },
  buttonSignUp: {
    '&&': {
      fontSize: FONTS.SIZES.m,
      fontWeight: '700',
      color: theme.palette.custom.primary,
      padding: 0,
      lineHeight: 'auto',
      textTransform: 'none',
    },
  },

  warningTextWrapper: {
    '&&': {
      marginTop: SPACES.xxxs,
      marginBottom: SPACES.xxxs,

      flexWrap: 'wrap',
      display: 'flex',
      alignItems: 'baseline',
      alignSelf: 'flex-start',
      gap: SPACES.xs,
    },
  },
  warningText: {
    '&&': {
      fontSize: FONTS.SIZES.s,
      fontWeight: '700',
      color: theme.palette.custom.darkBlue2,
    },
  },
  secondaryButton: {
    '&&': {
      fontSize: FONTS.SIZES.s,
      fontWeight: '700',
      textTransform: 'none',
    },
  },
  footerWrapper: {
    '&&': {
      textAlign: 'right',
      marginBottom: SPACES.s,

      [theme.breakpoints.down('laptop')]: {
        position: 'absolute',
        marginTop: '90vh',
        marginRight: 'auto',
        right: '20px',
        bottom: '20px',
      },

      [theme.breakpoints.up('laptop')]: {
        marginTop: 'auto',
        marginRight: SPACES.xxxxxxl,
      },
    },
  },
}))

export { useStyles }
